import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseBENG = props => <ServerComponentCaller url={"assets/data/pages/licencias/B-ENG.json"}/>;

export default LicenciaClaseBENG;